import { Injectable } from '@angular/core';
import { GraphQlRequestService } from '@gelato-api-ui/core/api/services/graph-ql-request.service';
import * as gql from 'gql-query-builder';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { PreviewArchiveGraphQlRequest } from '@api-ui-app/src/app/previews-archive/types/preview-archive-request';

@Injectable({ providedIn: 'root' })
export class PreviewsArchiveGraphQlService {
  constructor(private readonly graphQlRequestService: GraphQlRequestService) {}

  downloadMockups(request: PreviewArchiveGraphQlRequest) {
    const operation = 'downloadMockup';
    const variables = {
      width: { type: 'Float!', value: request.width },
      height: { type: 'Float!', value: request.height },
      format: { type: 'String', value: request.format },
      scene_ids: { type: '[String!]!', value: request.scene_ids },
      products: { type: '[MockupProductArgs!]!', value: request.products },
      sizing: { type: 'String', value: request.sizing },
    };

    const query = gql.query({
      operation,
      variables,
      fields: ['url', 'state', 'task_id'],
    });

    return this.graphQlRequestService.query(query, `${operation}`).pipe(
      map(response => response?.data?.[operation]),
      catchError(() => of(null)),
    );
  }
}
